import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../profile/Profile.css";
import Select from 'react-select/async';
import { CircularProgress } from '@mui/material';

const ProfileA = () => {
  const [invalidFopData, setInvalidFopData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [creatorSearchTerm, setCreatorSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const [showFopForm, setShowFopForm] = useState(false);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [contractorRestaurants, setContractorRestaurants] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [expandedItem, setExpandedItem] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [creators, setCreators] = useState([]);
  const [dlcData, setDlcData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fopData, setFopData] = useState({
    name_fop: '',
    contractor_id: '',
    rest_id: '',
    edrpou: '',
    user_id_ch: localStorage.getItem('userId')
  });

  useEffect(() => {
    fetchData();
    fetchCreators();
  }, []);

  useEffect(() => {
    if (invalidFopData.length > 0) {
      setIsLoading(true);
      const filtered = getFilteredData();
      Promise.all(filtered.map(item => fetchDlcData(item.id)))
        .finally(() => setIsLoading(false));
    }
  }, [invalidFopData, searchTerm, creatorSearchTerm, activeTab, startDate, endDate]);


  const fetchData = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get('https://bank2.daolog.net/invalid-fop-data', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setInvalidFopData(response.data);
    } catch (error) {
      console.error('Помилка отримання даних:', error);
      if (error.response?.status === 401) {
        window.location.href = '/login';
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getFilteredData = () => {
    return invalidFopData.filter(item => {
      const searchTermLower = searchTerm.toLowerCase();
      const creatorSearchTermLower = creatorSearchTerm.toLowerCase();
      
      const matchesSearch = !searchTerm || 
        item.contractor_name?.toLowerCase().includes(searchTermLower) ||
        item.restaurant_name?.toLowerCase().includes(searchTermLower);
      
      const matchesCreator = !creatorSearchTerm ||
        item.creator_username?.toLowerCase().includes(creatorSearchTermLower);
      
      const itemDate = new Date(item.created_at);
      itemDate.setHours(23, 59, 59, 999);
      
      const start = startDate ? new Date(startDate) : null;
      if (start) start.setHours(0, 0, 0, 0);
      
      const end = endDate ? new Date(endDate) : null;
      if (end) end.setHours(23, 59, 59, 999);
      
      const matchesDateRange = (!start || itemDate >= start) && (!end || itemDate <= end);
      
      switch(activeTab) {
        case 'unprocessed':
          return matchesSearch && matchesCreator && matchesDateRange && (!item.status || item.status === 'Необроблена');
        case 'processed':
          return matchesSearch && matchesCreator && matchesDateRange && item.status === 'Оброблена';
        case 'cancelled':
          return matchesSearch && matchesCreator && matchesDateRange && item.status === 'Скасована';
        default:
          return matchesSearch && matchesCreator && matchesDateRange;
      }
    });
  };



 

  const fetchDlcData = async (fopId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`https://bank2.daolog.net/dlc-by-fop/${fopId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setDlcData(prev => ({
        ...prev,
        [fopId]: response.data.dlc
      }));
    } catch (error) {
      console.error('Помилка отримання DLC:', error);
    }
  };


  const fetchCreators = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get('https://bank2.daolog.net/users', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setCreators(response.data);
    } catch (error) {
      console.error('Помилка отримання користувачів:', error);
    }
  };

  const loadContractorOptions = async (inputValue) => {
    try {
      const response = await axios.get('https://bank2.daolog.net/contractors-with-fop-count');
      return response.data
        .filter(contractor => 
          contractor.name.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map(contractor => ({
          value: contractor.id,
          label: `${contractor.name} (Створено ${contractor.current_fop_count} з ${contractor.fop_amount})`
        }));
    } catch (error) {
      console.error('Error loading contractors:', error);
      return [];
    }
  };

  const handleContractorSelect = async (selectedOption) => {
    if (selectedOption) {
      setSelectedContractor(selectedOption);
      setFopData(prev => ({ ...prev, contractor_id: selectedOption.value, rest_id: '' }));
      
      try {
        const response = await axios.get(`https://bank2.daolog.net/restaurants-by-contractor/${selectedOption.value}`);
        setContractorRestaurants(response.data);
      } catch (error) {
        console.error('Error fetching restaurants:', error);
        alert('Помилка при отриманні ресторанів');
      }
    }
  };

  const handleCreatorSearch = (e) => {
    setCreatorSearchTerm(e.target.value);
  };

  const filteredCreators = creators.filter(creator =>
    creator.username.toLowerCase().includes(creatorSearchTerm.toLowerCase())
  );

  const handleFopSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('authToken');
      await axios.post('https://bank2.daolog.net/create-fop', fopData, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      alert('FOP успішно створено');
      setFopData({
        name_fop: '',
        contractor_id: '',
        rest_id: '',
        edrpou: '',
        user_id_ch: localStorage.getItem('userId')
      });
      setShowFopForm(false);
      setExpandedItem(null);
      fetchData();
    } catch (error) {
      console.error('Error:', error);
      alert('Помилка при створенні FOP');
    }
  };

  const handleChange = (e) => {
    setFopData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleDownload = async (path) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login';
      return;
    }

    try {
      const pathParts = path.split('\\');
      const userId = pathParts[pathParts.indexOf('confiles') + 1];
      const fileName = pathParts[pathParts.length - 1];
      
      const response = await axios({
        method: 'GET',
        url: `https://bank2.daolog.net/invalid-fop-download/${userId}/${fileName}`,
        responseType: 'blob',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response?.status === 404) alert('Файл не знайдено');
      else if (error.response?.status === 401) {
        alert('Необхідна авторизація');
        window.location.href = '/login';
      }
      else alert('Помилка завантаження');
    }
  };

  const handleStatusUpdate = async (id, newStatus) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login';
      return;
    }

    try {
      await axios.put(`https://bank2.daolog.net/update-fop-status/${id}`, 
        { status: newStatus },
        { headers: { 'Authorization': `Bearer ${token}` }}
      );

      setInvalidFopData(prev => 
        prev.map(item => item.id === id ? {...item, status: newStatus} : item)
      );
      setSelectedItem(null);
    } catch (error) {
      console.error('Error:', error);
      alert('Помилка оновлення статусу');
    }
  };

  const filteredData = invalidFopData.filter(item => {
    const searchTermLower = searchTerm.toLowerCase();
    const creatorSearchTermLower = creatorSearchTerm.toLowerCase();
    
    const matchesSearch = !searchTerm || 
      item.contractor_name?.toLowerCase().includes(searchTermLower) ||
      item.restaurant_name?.toLowerCase().includes(searchTermLower);
    
    const matchesCreator = !creatorSearchTerm ||
      item.creator_username?.toLowerCase().includes(creatorSearchTermLower);
    
    const itemDate = new Date(item.created_at);
    itemDate.setHours(23, 59, 59, 999);
    
    const start = startDate ? new Date(startDate) : null;
    if (start) start.setHours(0, 0, 0, 0);
    
    const end = endDate ? new Date(endDate) : null;
    if (end) end.setHours(23, 59, 59, 999);
    
    const matchesDateRange = (!start || itemDate >= start) && (!end || itemDate <= end);
    
    switch(activeTab) {
      case 'unprocessed':
        return matchesSearch && matchesCreator && matchesDateRange && (!item.status || item.status === 'Необроблена');
      case 'processed':
        return matchesSearch && matchesCreator && matchesDateRange && item.status === 'Оброблена';
      case 'cancelled':
        return matchesSearch && matchesCreator && matchesDateRange && item.status === 'Скасована';
      default:
        return matchesSearch && matchesCreator && matchesDateRange;
    }
  });

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '120px auto 0',
      padding: '0 20px'
    },
    header: {
      color: '#333',
      borderBottom: '2px solid #333',
      paddingBottom: '10px'
    },
    searchContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    searchInput: {
      padding: '10px',
      width: '300px',
      borderRadius: '5px',
      border: '1px solid #ddd',
      fontSize: '16px'
    },
    creatorSearchContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    creatorSearchInput: {
      padding: '10px',
      width: '300px',
      borderRadius: '5px',
      border: '1px solid #ddd',
      fontSize: '16px'
    },
    creatorsList: {
      position: 'absolute',
      width: '300px',
      maxHeight: '200px',
      overflowY: 'auto',
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '5px',
      zIndex: 1000
    },
    creatorItem: {
      padding: '8px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f5f5f5'
      }
    },
    dateContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '20px'
    },
    dateInput: {
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ddd',
      fontSize: '16px'
    },
    addButton: {
      padding: '10px 15px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '20px'
    },
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '10px',
      width: '500px',
      position: 'relative'
    },
    formInput: {
      marginTop: '10px',
      padding: '8px',
      width: '100%',
      borderRadius: '5px',
      border: '1px solid #ddd'
    },
    submitButton: {
      marginTop: '20px',
      padding: '10px',
      width: '100%',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    },
    headerWithButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    expandedForm: {
      backgroundColor: '#f9f9f9',
      padding: '20px',
      borderRadius: '5px',
      marginTop: '20px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Заявки</h1>
      
      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder="Пошук за назвою контрагента або ресторану..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={styles.searchInput}
        />
        <button onClick={() => setShowFopForm(true)} style={styles.addButton}>
          +
        </button>
      </div>
  
      <div style={styles.creatorSearchContainer}>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Пошук за створювачем..."
            value={creatorSearchTerm}
            onChange={handleCreatorSearch}
            style={styles.creatorSearchInput}
          />
          {creatorSearchTerm && filteredCreators.length > 0 && (
            <div style={styles.creatorsList}>
              {filteredCreators.map(creator => (
                <div
                  key={creator.id}
                  style={styles.creatorItem}
                  onClick={() => setCreatorSearchTerm(creator.username)}
                >
                  {creator.username}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
  
      <div style={styles.dateContainer}>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={styles.dateInput}
        />
        <span>до</span>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={styles.dateInput}
        />
      </div>
  
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
        {[
          { key: 'all', text: 'Усі', color: ['#666', '#999'] },
          { key: 'unprocessed', text: 'Необроблені', color: ['#2196F3', '#90CAF9'] },
          { key: 'processed', text: 'Оброблені', color: ['#4CAF50', '#A5D6A7'] },
          { key: 'cancelled', text: 'Скасовані', color: ['#F44336', '#EF9A9A'] }
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '10px 20px',
              backgroundColor: activeTab === tab.key ? tab.color[0] : tab.color[1],
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            {tab.text}
          </button>
        ))}
      </div>
  
      {isLoading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          margin: '20px 0' 
        }}>
          <CircularProgress />
        </div>
      ) : (
        <div className="fop-list">
          {filteredData
            .filter(item => 
              item.restaurant_name && 
              item.contractor_name && 
              item.type && 
              item.creator_username && 
              dlcData[item.id]
            )
            .map((item) => (
              <div key={item.id} className="invalid-fop-container">
                <div className="invalid-fop-header" style={styles.headerWithButton}>
                  <h3>{item.contractor_name}</h3>
                  <h4>ID заявки: {item.id}</h4>
                  {(!item.status || item.status === 'Необроблена') && (
                    <button
                      onClick={() => setExpandedItem(expandedItem === item.id ? null : item.id)}
                      style={{
                        ...styles.addButton,
                        padding: '5px 10px',
                        fontSize: '16px'
                      }}
                    >
                      +
                    </button>
                  )}
                </div>
                
                <div className="invalid-fop-details">
                  <p><strong>Статус заявки:</strong> {item.status || 'Нова'}</p>
                  <p><strong>ФОП:</strong> {item.name_fop}</p>
                  <p><strong>ЄДРПОУ:</strong> {item.edrpou}</p>
                  <p><strong>Ресторан:</strong> {item.restaurant_name}</p>
                  <p><strong>Контрагент:</strong> {item.contractor_name}</p>
                  <p><strong>Тип заявки:</strong> {item.type}</p>
                  <p><strong>Хто створив:</strong> {item.creator_username}</p>
                  <p><strong>Розширення файлу:</strong> {dlcData[item.id]}</p>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                    <button 
                      onClick={() => handleDownload(item.path)}
                      className="download-button"
                    >
                      Завантажити файл
                    </button>
                    
                    <div className="status-buttons">
                      <button 
                        onClick={() => handleStatusUpdate(item.id, 'Оброблена')}
                        className="status-button processed"
                      >
                        ОБРОБЛЕНА
                      </button>
                      <button 
                        onClick={() => handleStatusUpdate(item.id, 'Скасована')}
                        className="status-button cancelled"
                      >
                        СКАСОВАНА
                      </button>
                    </div>
                  </div>
  
                  {expandedItem === item.id && (
                    <div style={styles.expandedForm}>
                      <h4>Створення нового FOP</h4>
                      <form onSubmit={handleFopSubmit}>
                        <Select
                          styles={{
                            control: (base) => ({
                              ...base,
                              marginTop: '10px',
                              padding: '4px',
                              borderRadius: '5px',
                              border: '1px solid #ddd'
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999
                            })
                          }}
                          placeholder="Виберіть контрагента..."
                          value={selectedContractor}
                          onChange={handleContractorSelect}
                          loadOptions={loadContractorOptions}
                          defaultOptions
                          isClearable
                          isSearchable
                          noOptionsMessage={() => "Немає результатів"}
                          loadingMessage={() => "Завантаження..."}
                        />
  
                        <select
                          name="rest_id"
                          value={fopData.rest_id}
                          onChange={handleChange}
                          style={styles.formInput}
                          required
                        >
                          <option value="">Виберіть ресторан</option>
                          {contractorRestaurants.map(restaurant => (
                            <option key={restaurant.id} value={restaurant.id}>
                              {restaurant.name}
                            </option>
                          ))}
                        </select>
  
                        <input
                          type="text"
                          name="name_fop"
                          value={fopData.name_fop}
                          onChange={handleChange}
                          placeholder="Назва FOP"
                          style={styles.formInput}
                          required
                        />
  
                        <input
                          type="text"
                          name="edrpou"
                          value={fopData.edrpou}
                          onChange={handleChange}
                          placeholder="ЄДРПОУ"
                          style={styles.formInput}
                          required
                        />
  
                        <button type="submit" style={styles.submitButton}>
                          Створити ФОП/ТОВ запис
                        </button>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      )}
  
      {showFopForm && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <button
              onClick={() => setShowFopForm(false)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: 'red'
              }}
            >
              ×
            </button>
            
            <h4 style={{ marginTop: 0 }}>Створення нового FOP</h4>
            
            <form onSubmit={handleFopSubmit}>
              <Select
                styles={{
                  control: (base) => ({
                    ...base,
                    marginTop: '10px',
                    padding: '4px',
                    borderRadius: '5px',
                    border: '1px solid #ddd'
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
                placeholder="Виберіть контрагента..."
                value={selectedContractor}
                onChange={handleContractorSelect}
                loadOptions={loadContractorOptions}
                defaultOptions
                isClearable
                isSearchable
                noOptionsMessage={() => "Немає результатів"}
                loadingMessage={() => "Завантаження..."}
              />
  
              <select
                name="rest_id"
                value={fopData.rest_id}
                onChange={handleChange}
                style={styles.formInput}
                required
              >
                <option value="">Виберіть ресторан</option>
                {contractorRestaurants.map(restaurant => (
                  <option key={restaurant.id} value={restaurant.id}>
                    {restaurant.name}
                  </option>
                ))}
              </select>
  
              <input
                type="text"
                name="name_fop"
                value={fopData.name_fop}
                onChange={handleChange}
                placeholder="Назва FOP"
                style={styles.formInput}
                required
              />
  
              <input
                type="text"
                name="edrpou"
                value={fopData.edrpou}
                onChange={handleChange}
                placeholder="ЄДРПОУ"
                style={styles.formInput}
                required
              />
  
              <button type="submit" style={styles.submitButton}>
                Створити ФОП/ТОВ запис
              </button>
            </form>
          </div>
        </div>
      )}
  
      {selectedItem && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <button
              onClick={() => setSelectedItem(null)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '10px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: 'red'
              }}
            >
              ×
            </button>
            
            <h4 style={{ marginTop: 0 }}>Деталі заявки</h4>
            
            <div style={{ marginBottom: '20px' }}>
              <p><strong>ID заявки:</strong> {selectedItem.id}</p>
              <p><strong>Тип заявки:</strong> {selectedItem.type || 'Не вказано'}</p>
              <p><strong>Статус заявки:</strong> {selectedItem.status || 'Нова'}</p>
              <p><strong>ФОП:</strong> {selectedItem.name_fop}</p>
              <p><strong>ЄДРПОУ:</strong> {selectedItem.edrpou}</p>
              <p><strong>Ресторан:</strong> {selectedItem.restaurant_name}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileA;